import { TENANT_CH, TENANT_COM, TENANT_FR, TENANT_IT } from 'shared/consts'

export const isExpandedByDefaultForTenant = (tenant: string): boolean => {
  const tenantsToCollapse = [TENANT_COM, TENANT_IT, TENANT_CH, TENANT_FR]
  return !tenantsToCollapse.includes(tenant)
}
